import { isMobile } from "../bridges/BridgeServices";

export const isTokenPresent = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return isMobile() || isInsideIframe();
};
export const isInsideIframe = () => {
  return parent !== window;
};
